import { Fragment } from "react";
import HeroSection from "./components/HeroSection";
// import OurPartners from './components/OurPartners';
import ChooseFWPI from "./components/ChooseFWPI";
import OurMembers from "./components/OurMembers";
import Membership from "./components/Membership";
import BecomeVerifiedMember from "./components/BecomeVerifiedMember";
import MembershipCard from "./components/MembershipCard";
import Mailer from "./components/Mailer";
import KeyPoints from "./components/KeyPoints";
import CardScroller from "./components/CardScroller";
import YouTubePlaylistScroller from "../../Components/YoutubePlaylistScroller";

const certificates = [
  { name: "IYO ALLINCE", path: "/assets/certificates/IYO.png" },
  { name: "IAOT", path: "/assets/certificates/IAOTH.png" },
  { name: "IYO-USA", path: "/assets/certificates/IYO-USA.png" },
  { name: "NCVE", path: "/assets/certificates/NCVE.png" },
  { name: "ISO", path: "/assets/certificates/ISO.png" },
  { name: "CA", path: "/assets/certificates/CA.jpg" },
  { name: "MSME", path: "/assets/certificates/MSME.png" },
];

const partners = [
  { id: 1, path: "/assets/partners/cult-fit.png", name: "Cult.fit Logo" },
  {
    id: 2,
    path: "/assets/partners/anytime-fitness.png",
    name: "Anytime Fitness Logo",
  },
  { id: 3, path: "/assets/partners/fab-sports.png", name: "FAB Sports Logo" },
  {
    id: 4,
    path: "/assets/partners/afton.png",
    name: "Afton Fitness Equipment Logo",
  },
  { id: 5, path: "/assets/partners/impulse.jpeg", name: "Impulse" },
  { id: 6, path: "/assets/partners/smo.png", name: "Cosmos" },
  { id: 7, path: "/assets/partners/goldgym.png", name: "Gold Gym" },
  { id: 8, path: "/assets/partners/gymline.jpeg", name: "Gym Line" },
  { id: 9, path: "/assets/partners/blueclaws.png", name: "Blue Clows" },
];

const GYM_FACILITIES = [
  { name: "Hi-Tech", path: "/assets/gyms/hitech.png" },
  { name: "core-fitness", path: "/assets/gyms/core-fitness.png" },
  { name: "hrw", path: "/assets/gyms/hrw.png" },
  { name: "R8-Academy", path: "/assets/gyms/r8academy.png" },
];

const Dashboard = () => {
  return (
    <Fragment>
      <HeroSection />
      <CardScroller
        py={16}
        speed={200}
        id={"Our-Partners"}
        title="Our Partners"
        buttonName="Read More"
        items={partners}
        isHideButton={true}
      />
      {/* <OurPartners /> */}
      <KeyPoints />
      <CardScroller
        py={16}
        speed={200}
        id={"accreditation-affiliation"}
        title="Accreditation & Affiliations"
        buttonName="Read More"
        items={certificates}
      />
      <ChooseFWPI />
      <OurMembers />
      <Membership />
      <BecomeVerifiedMember />
      <CardScroller
        py={16}
        pathname={"/services/elevate-standards"}
        title="FWPI Approved Gym Facilities"
        buttonName="Join Now"
        items={GYM_FACILITIES}
      />
      <MembershipCard />
      <YouTubePlaylistScroller
        videoIds={[
          "mhgXIkhgBTE",
          "BL8yMZhKXrU",
          "wpCZvdmvzfA",
          "817qcEA_GDs",
          "mhgXIkhgBTE",
        
          // add all video IDs from playlist manually
        ]}
      />
      <Mailer />
    </Fragment>
  );
};

export { Dashboard };
